import { Loader2 } from 'lucide-react';

/**
 * Sprint 37 — Spinner visual con texto para feedback de carga en modales.
 * Reemplaza el patrón "Cargando..." sin animación que dejaba al usuario
 * dudando si la UI estaba congelada.
 */
interface Props {
  texto?: string;
  className?: string;
}

export function SpinnerInline({ texto = 'Cargando…', className }: Props) {
  return (
    <div
      className={`flex items-center justify-center gap-2 text-slate-500 ${className ?? 'py-6'}`}
      role="status"
      aria-live="polite"
    >
      <Loader2 className="h-5 w-5 animate-spin" aria-hidden="true" />
      <span>{texto}</span>
    </div>
  );
}
